
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import logger from 'utils/logger';

export default function Custom404() {
  const { asPath, replace } = useRouter();

  useEffect(() => {
    logger.error({
      message: '404 page not found',
      url: asPath,
    });
    replace('/');
  }, []);

  return null;
}
